<template>
  <div class="tncContainer">
    <div class="tncHeader">
      <div class="md-title" v-if="loadingTerms">Terms And Conditions</div>
      <div class="md-title" v-else>{{termsContent.title}}</div>
      <md-progress-bar v-if="loadingTerms" md-mode="indeterminate"></md-progress-bar>
      <b-row class="mt-2 ml-2">
        <!-- <md-button class="md-primary" @click="disagreeToTerms">Close</md-button> -->
        <moow-button 
          :type="['dark', 'outlined', 'flat']" 
          btnText="Close" 
          @mClick="disagreeToTerms"
        />
        <moow-button 
          v-if="!loadingTerms && !hideActions"
          :type="['light']" 
          :btnText="agreeText" 
          @mClick="agreeToTerms"
          :disabled="requireBottom && disableAgree"
          :loading="loading"
          tooltip="Scroll to bottom to agree"
          class="ml-2"
        />
        <!-- <md-button  class="md-primary play-cta-button makeup" v-if="!loadingTerms && !hideActions" @click="agreeToTerms" :disabled="requireBottom && disableAgree">
          {{agreeText}}
          <md-tooltip md-direction="bottom" :md-active="requireBottom && disableAgree">Scroll to bottom to agree</md-tooltip>  
        </md-button> -->
      </b-row>
    </div>

    <div class="tncBody" >
      <b-row class="mb-3">
        <b-col>{{termsContent.prefix}}</b-col>
      </b-row>
      <b-row v-for="(part,index) in termsContent.parts " :key="index" >
        <b-col>
          <p class="moow-subheader mt-4">{{part.title}}</p>
          <p class="moow-info-txt">{{part.body}}</p>
        </b-col>
      </b-row>
      <b-row v-observe-visibility="visibilityChanged">
        <b-col>{{termsContent.suffix}}</b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Snackbar from '../../components/snackbar.vue'
  import{ getTermsAndConditions, getAccomodationTerms } from '../../terms/repository/termsRepository.js'
  export default {
    props: {
      hideActions:{
        type: Boolean,
        required: false,
        default: false
      },
      requireBottom: {
        type: Boolean,
        default: true,
        required: false
      },
      termsType: {
        type: String,
        required: false
      },
      params: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'error-snackbar': Snackbar
    },
    data() {
      return {
        termsContent:"",
        loadingTerms:true,
        disableAgree: true
      }
    },
    computed: {
      agreeText(){
        if(this.termsType == "accomodation") return "Sign now"
        else return "I agree"
      }
    },
    watch: {
    },
    created(){
      if(this.termsType && this.termsType == "accomodation") this.getAccomodationTerms() 
      else this.getTermsAndConditions()
    },
    methods: {
      visibilityChanged(isVisible, entry){
        this.disableAgree = !isVisible; // disable when NOT visible
      },
      agreeToTerms(){
        this.$emit('makeDecision', true)
      },
      disagreeToTerms(){
        this.$emit('makeDecision', false)
      },
      getAccomodationTerms(){
        this.loadingTerms=true
        getAccomodationTerms()
          .then(terms => {
            this.termsContent=this.addParamsToTerms(terms, this.params)
            // this.termsContent=terms
            this.loadingTerms=false
          })
          .catch(err =>{
            console.log('err:', err);
            this.$emit('makeDecision', false)
          })
      },
      getTermsAndConditions(){
        this.loadingTerms=true
        getTermsAndConditions()
          .then(terms => {
            this.termsContent=terms
            this.loadingTerms=false
          })
          .catch(err =>{
            this.$emit('makeDecision', false)
          })
      },
      addParamsToTerms(terms, params){
        if(params) {
          terms.prefix = terms.prefix.replace("${representation}", params.ownerName)
          terms.prefix = terms.prefix.replace("${username}", params.tenantName)
          terms.parts[0].body = terms.parts[0].body.replace("${property}", params.property)
        }
        return terms
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/global.css';


  .terms-container{
    position: relative;
  }

  .tncContainer{
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 1em;
  }

  .tncHeader{
    padding:1em;
    flex: 0 1 auto;
  }

  .tncBody{
    flex: 1 1 auto;  
    padding: 30px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/TermsAndConditions.vue